import { useTheme } from "@emotion/react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import { useQuery } from "react-query";
import { getSingleProdServ } from "../../../services/amtc-service";
import QueryKey from "../../../utils/QueryKey";
import { useEffect, useState } from "react";
import { datePickerformat, isNotEmpty } from "../../../utils/format";
import { updateProdAgreeServ } from "../../../services/com-service";
import { customAlert, notify } from "../../../components/notify";
import route from "../../../utils/Routes";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import BackButton from "../../../components/BackButton";
import LabelTxtFieldInfo from "../../../components/LabelTxtFieldInfo";
import BgBoxOld from "../../../components/BgBoxOld";


function UpdateAgreeDetailsPg() {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const [formErrors, setFormErrors] = useState({});
    const { prodId, comId } = location.state || {};
    const { setLoadingScreen, setNavComValue } = useAuthContext();
    const { isLoading, isError, error, data: prodData } = useQuery([QueryKey.amtcProdInfo, prodId, "com", comId], () => getSingleProdServ(prodId, "com", comId),
        {
            enabled: isNotEmpty(prodId),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        })

    useEffect(() => {
        setNavComValue({ comId })
        return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, comId]);

    useEffect(() => {
        setLoadingScreen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        if (!prodId)
            navigate("/", { replace: true })
        if (!comId)
            navigate("/", { replace: true })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [prodId, comId])



    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData);
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);
        if (Object.keys(errorsObj).length > 0)
            return;
        setLoadingScreen(true);
        try {
            const payload = {
                comId,
                amtcProdIdStrg: prodId,
                comProdIdStrg: inputObject.comProdIdStrg,
                priceAgreeId: inputObject.priceAgreeId,
                agreedQty: isNotEmpty(inputObject.agreedQty) ? inputObject.agreedQty : 0,
                AgreedPrice: isNotEmpty(inputObject.AgreedPrice) ? inputObject.AgreedPrice : 0,
                comProdTax: isNotEmpty(inputObject.comProdTax) ? inputObject.comProdTax : 0,
                agreedFrom: isNotEmpty(inputObject.agreedFrom) ? inputObject.agreedFrom : null,
                agreedTo: isNotEmpty(inputObject.agreedTo) ? inputObject.agreedTo : null,
            }
            const { message } = await updateProdAgreeServ(payload);
            notify("success", message);
            navigate(`${route.aComProdInfo}/?prodId=${prodId}&comId=${comId}`, { replace: true });
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    };

    function validate(values) {
        const errors = {};

        if (!values.comProdIdStrg)
            errors.comProdIdStrg = "Material Code is required!";

        return errors;
    };

    function handleCancel() {
        navigate(`${route.aComProdInfo}/?prodId=${prodId}&comId=${comId}`);
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (<form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%" }}>
        <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5} width={"100%"}>
            <BackButton width={"20%"} />
            <Stack direction={"row"} alignItems={'center'} justifyContent={'center'} width={"60%"}>
                <Typography width={"33.3%"} sx={{ fontSize: 18, fontWeight: 500 }}>Update Agreement Details</Typography>
            </Stack>
            <Box width={"20%"} />
        </Stack>
        <BgBoxOld height={"93%"} py={1}>
            {prodData && <Stack >
                <Stack direction={"row"} alignItems={"center"} gap={2}>
                    <LabelTxtFieldInfo defaultValue={prodData?.prodName} name="prodName" title="Product Name"
                        width={300} height={25} borderRadius={1} bgColor={"rgba(162, 214, 249, 0.18)"} readOnly={true} />
                    <LabelTxtFieldInfo defaultValue={prodData?.amtcProdIdStrg} bgColor={"rgba(162, 214, 249, 0.18)"} readOnly={true}
                        name="amtcProdIdStrg" title="Amtc Product ID" width={300} height={25} borderRadius={1} />
                    {/* <LabelTxtFieldInfo defaultValue={prodData?.comProdIdStrg}
                        name="comProdIdStrg" title="Material Code" width={300} height={25} borderRadius={1} /> */}
                </Stack>
                <Stack direction={"row"} gap={10} mt={1}>
                    <Stack mt={3} width={300} gap={2}>
                        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} width={"100%"}>
                            <Typography fontSize={13} sx={{ color: formErrors.comProdIdStrg ? "red" : "rgba(0, 0, 0, 1)" }}>
                                Material Code *
                            </Typography>
                            <TextField defaultValue={prodData?.comProdIdStrg} name='comProdIdStrg' size='small'
                                sx={{ '& .MuiOutlinedInput-root': { fontSize: 13, width: 150, color: "rgba(0, 0, 0, 1)" } }}
                                error={formErrors.comProdIdStrg && true} helperText={formErrors.comProdIdStrg}
                            />
                        </Stack>
                        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} width={"100%"}>
                            <Typography fontSize={13} sx={{ color: "rgba(0, 0, 0, 1)" }}>
                                Price Agreement Id
                            </Typography>
                            <TextField defaultValue={prodData?.priceAgreeId} name='priceAgreeId' size='small'
                                sx={{ '& .MuiOutlinedInput-root': { fontSize: 13, width: 150, color: "rgba(0, 0, 0, 1)" } }} />
                        </Stack>
                        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} width={"100%"}>
                            <Typography fontSize={13} sx={{ color: "rgba(0, 0, 0, 1)" }}>
                                Agreed  Price <Typography component="span" fontSize={10} variant="caption">(OMR)</Typography>
                            </Typography>
                            <TextField defaultValue={prodData?.AgreedPrice} name='AgreedPrice' type='number' size='small'
                                sx={{ '& .MuiOutlinedInput-root': { fontSize: 13, width: 150, color: "rgba(0, 0, 0, 1)" } }} />
                        </Stack>

                        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} width={"100%"}>
                            <Typography fontSize={13} sx={{ color: "rgba(0, 0, 0, 1)" }}>
                                Agreed Quantity <Typography fontSize={10} component="span" variant="caption" >(Nos)</Typography>
                            </Typography>
                            <TextField defaultValue={prodData?.agreedQty} name='agreedQty' type='number' size='small'
                                sx={{ '& .MuiOutlinedInput-root': { fontSize: 13, width: 150, color: "rgba(0, 0, 0, 1)" } }} />
                        </Stack>
                    </Stack>
                    <Stack mt={3} width={250} gap={2}>
                        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} width={"100%"}>
                            <Typography fontSize={13} sx={{ color: "rgba(0, 0, 0, 1)" }}>
                                Agreed From
                            </Typography>
                            <TextField defaultValue={datePickerformat(prodData?.agreedFrom)} name='agreedFrom' type='date' size='small'
                                sx={{ '& .MuiOutlinedInput-root': { fontSize: 13, width: 150, color: "rgba(0, 0, 0, 1)" } }} />
                        </Stack>
                        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} width={"100%"}>
                            <Typography fontSize={13} sx={{ color: "rgba(0, 0, 0, 1)" }}>
                                Agreed To
                            </Typography>
                            <TextField defaultValue={datePickerformat(prodData?.agreedTo)} name='agreedTo' type='date' size='small'
                                sx={{ '& .MuiOutlinedInput-root': { fontSize: 13, width: 150, color: "rgba(0, 0, 0, 1)" } }} />
                        </Stack>
                        <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} width={"100%"}>
                            <Typography fontSize={13} sx={{ color: "rgba(0, 0, 0, 1)" }}>
                                Tax <Typography component="span" fontSize={10} variant="caption">(in %)</Typography>
                            </Typography>
                            <TextField defaultValue={prodData?.comProdTax} name='comProdTax' type='number' size='small'
                                sx={{ '& .MuiOutlinedInput-root': { fontSize: 13, width: 150, color: "rgba(0, 0, 0, 1)" } }} />
                        </Stack>
                    </Stack>
                </Stack>

                <Stack direction={"row"} alignItems={"center"} sx={{ width: "80%", justifyContent: "end", mt: 5 }} >
                    <Button variant="outlined" onClick={handleCancel} sx={{
                        fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
                        color: theme.palette.custom.btn, mr: 2,
                    }}>CANCEL</Button>
                    <Button variant="contained" type="submit"
                        sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", mr: 10 }}>
                        SAVE</Button>
                </Stack>
            </Stack>}
        </BgBoxOld>
    </form>
    )
}
export default UpdateAgreeDetailsPg